module.exports = __webpack_public_path__ + "img/chevron-up.88669296.svg";